import axios, { getData } from 'lib/axios'
import { downloadResponseFile } from 'services/helper/fileDownload'

export const getQueryApprovalReports = async (status, page, perPage, query = {}) => {
  return axios
    .get('/approvals/reports', {
      params: {
        approval: status,
        page,
        per_page: perPage,
        sort_by: query.sortBy,
        sort_order: query.sortOrder,
      },
    })
    .then(getData)
}

export const getClaimsPending = async (page = 1, perPage = 15, query = {}) => {
  return axios
    .get('/approvals/claims/pending', {
      params: {
        page,
        per_page: perPage,
        sort_by: query.sortBy,
        sort_order: query.sortOrder,
      },
    })
    .then(getData)
}

export const rejectExpense = async (reportId, expenseId, feedback) => {
  return axios.post(`/expenses/${expenseId}/reject`, { feedback, report_id: reportId }).then(getData)
}

export const getSingleApprovalReport = async (id) => {
  return axios.get(`/approvals/reports/${id}`).then(getData)
}
export const getRespondedReport = async (page, perPage, query = {}) => {
  return axios
    .get('/approvals/report-responded', {
      params: {
        page,
        per_page: perPage,
        sort_by: query.sortBy,
        sort_order: query.sortOrder,
        month: query.month,
        year: query.year,
        date_from: query.dateFrom,
        date_to: query.dateTo,
      },
    })
    .then(getData)
}
export const getSingleReimbursementReport = async (id) => {
  return axios.get(`/finance/reimbursement/reports/${id}`).then(getData)
}

export const postApproveReport = async (data, reportId) => {
  return axios.post(`/approvals/reports/${reportId}`, data).then(getData)
}

export const getReimburseReports = async () => {
  return axios.get('/finance/reimbursement/reports').then(getData)
}
export const queryReimburseReports = async (query) => {
  return axios.get(`/finance/reimbursement/reports?status=${query}`).then(getData)
}

export const postUpdateReimbursement = async (data) => {
  return axios.post('/finance/reimbursement/status', data).then(getData)
}

export const postDownloadReimbursementTxt = async (data) => {
  return axios.post('/finance/reimbursement/reports', data).then(getData)
}

const buildClaimsExportFileName = (extension, query = {}) => {
  if (query.dateFrom && query.dateTo) {
    return `claims_responded_${query.dateFrom}_to_${query.dateTo}.${extension}`
  }

  if (query.month && query.year) {
    return `claims_responded_${query.year}_${query.month.toString().padStart(2, '0')}.${extension}`
  }

  return `claims_responded.${extension}`
}

export const exportClaimsToExcel = async (query = {}) => {
  return axios
    .get('/approvals/export-claims-excel', {
      params: {
        month: query.month,
        year: query.year,
        date_from: query.dateFrom,
        date_to: query.dateTo,
      },
      responseType: 'blob',
    })
    .then((response) => {
      downloadResponseFile(response, {
        fileName: buildClaimsExportFileName('xlsx', query),
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        successMessage: 'Claims Excel export downloaded.',
      })
      return response
    })
}

export const exportClaimsToPdf = async (query = {}) => {
  return axios
    .get('/approvals/export-claims-pdf', {
      params: {
        month: query.month,
        year: query.year,
        date_from: query.dateFrom,
        date_to: query.dateTo,
      },
      responseType: 'blob',
    })
    .then((response) => {
      downloadResponseFile(response, {
        fileName: buildClaimsExportFileName('pdf', query),
        contentType: 'application/pdf',
        successMessage: 'Claims PDF export downloaded.',
      })
      return response
    })
}
